var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegionalSchoolDistrict({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.099,
    height: 25.445,
    viewBox: "0 0 31.099 25.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f003c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "school_FILL0_wght400_GRAD0_opsz48",
    className: "cls-1",
    d: "M17.514,31.445,7.266,25.826V17.344L2,14.482,17.514,6,33.1,14.482v11.2h-2.12V15.719l-3.216,1.626v8.482Zm0-10.885,11.132-6.079L17.514,8.509,6.453,14.482Zm0,8.482,8.128-4.488V18.617l-8.128,4.347L9.386,18.546v6.008ZM17.55,20.56ZM17.514,23.175ZM17.514,23.175Z",
    transform: "translate(-2 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionalSchoolDistrict);
export default __webpack_public_path__ + "static/media/regional-school-district.b073f8b96ca0cf7761a51b8c55060528.svg";
export { ForwardRef as ReactComponent };